export const EnergyKinds = [
  'Water',
  'Propane',
  'Diesel',
  'Solar',
  'Wind',
  'Hydro',
  'Electricity',
  'Electricity/ Gas',
  'Geothermal',
  'Diesel or Biodiesel',
  'LPG',
  'Natural Gas',
  'Heat Capture',
  'NA',
] as const;
export type EnergyKind = (typeof EnergyKinds)[number];

// --- Sort model (Plan 07-05; Name added by alphabetic-card-sorting) ---
// Each dimension declares how its values compare. Index 0 is the default.
export const TechSortDimensions = [
  { name: 'Energy Use Per Year', value: 'energyUsePerYr', kind: 'numeric' },
  { name: 'Design Life', value: 'designLife', kind: 'numeric' },
  { name: 'Cost Per Unit', value: 'capitalCostPerUnit', kind: 'numeric' },
  { name: 'Name', value: 'name', kind: 'text' },
] as const;
export type TechSortDimension = (typeof TechSortDimensions)[number];

export type TechSortState = {
  dimension: TechSortDimension;
  direction: 'asc' | 'desc';
};

// Case- and accent-insensitive, with natural number order ("Pump 2" < "Pump 10").
const textCollator = new Intl.Collator('en', {
  sensitivity: 'base',
  numeric: true,
});

function textSortValue(item: unknown, key: string): string {
  const raw = (item as Record<string, unknown>)[key];
  return raw == null ? '' : String(raw).trim();
}

export function sortTechItemsByState<T>(
  items: T[],
  sortState: TechSortState,
): T[] {
  if (sortState.dimension.kind === 'text') {
    const key = sortState.dimension.value;
    // Blank values go last in both directions; ties keep incoming order.
    return [...items].sort((a, b) => {
      const aVal = textSortValue(a, key);
      const bVal = textSortValue(b, key);
      if (!aVal || !bVal) return Number(!aVal) - Number(!bVal);
      const order = textCollator.compare(aVal, bVal);
      return sortState.direction === 'asc' ? order : -order;
    });
  }

  return [...items].sort((a, b) => {
    const aVal = Number(
      (a as Record<string, unknown>)[sortState.dimension.value],
    );
    const bVal = Number(
      (b as Record<string, unknown>)[sortState.dimension.value],
    );
    if (isNaN(aVal)) return 1;
    if (isNaN(bVal)) return -1;
    return sortState.direction === 'asc' ? aVal - bVal : bVal - aVal;
  });
}

type TechItemWithEnergy = { energySource?: string; energySink?: string };
export function getEnergyField(item: TechItemWithEnergy): string | undefined {
  return item.energySink ?? item.energySource;
}

export const TabKinds = [
  'conventionalAlternative',
  'reducedCarbonAlternative',
  'zeroCarbonAlternative',
] as const;

export type Tab = (typeof TabKinds)[number];
